import { APIForm } from './_api-form.js';
class RegisterForm extends APIForm {
  constructor() {
    super();
    this._successModalId = null;
    this._countryField = null;
    this._regionField = null;
  }
  connectedCallback() {
    super.connectedCallback();
    this._successModalId = this.getAttribute('data-success');
    this._initializeConditionalFields();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  _getDefaultEndpoint() {
    return "/wp-json/api/v1/ambassador/register";
  }
}
customElements.define('register-form', RegisterForm);